<style>
.animatedNumber {
	display: inline-block;
	position: relative;
}

.is-negative {
	color: red;
}
</style>

<template>
	<span :class='"animatedNumber " + (animatedNumber < 0 ? "is-negative" : "")'
		>{{ animatedFormattedNumber() }}
		{{ valueUnit() }}</span
	>
</template>

<script>
import gsap from "gsap";
// Other components
import { i18n } from "../utils";

export default {
	props: {
		number: Number,
		prevNumber: Number,
		valueUnits: Object,
		animationDuration: {
			type: Number,
			default: 2,
		},
		srvNumeralFormat: {
			type: String,
			default: "0,0[.]", // Is equivalent to `numeral.format`
		},
	},
	data: function () {
		return {
			animatedNumber: this.prevNumber,
		};
	},
	computed: {},
	mounted() {
		// pp.log("mounted with", this.number, this.prevNumber, this.animationDuration, this.srvNumeralFormat);
		gsap.to(this.$data, {
			duration: this.animationDuration,
			animatedNumber: parseFloat(this.number),
			ease: "power2.in",
			overwrite: true,
		});
		this.$watch("number", this.animateNumberChange);
	},
	beforeDestroy() {
		gsap.killTweensOf(this.$data);
	},
	methods: {
		animateNumberChange(newVal, oldVal) {
			// pp.log("newVal, oldVal", newVal, oldVal);
			gsap.to(this.$data, {
				duration: this.animationDuration,
				animatedNumber: parseFloat(newVal),
				ease: "power2.in",
				overwrite: true,
			});
		},
		animatedFormattedNumber() {
			return numeral(this.animatedNumber).format(this.srvNumeralFormat);
		},
		valueUnit() {
			if (this.valueUnits !== undefined) {
				let valueToShow =
					this.valueUnits[I18n.locale] ||
					Object.values(this.valueUnits)[0] ||
					"";
				if (valueToShow.length > 1) {
					valueToShow = " " + valueToShow;
				}
				return valueToShow;
			}
			// Else
			return "";
		},
	},
};
</script>
